import { CSSProperties } from 'react'

import { RCFC } from 'utils/types'
import { cn } from 'utils'
import { RowComponentModel } from 'api'

import classes from './row.module.css'

interface RowProps
  extends Omit<RowComponentModel<any, any, any>, 'second_section' | 'first_section'> {}

export const Row: RCFC<RowProps> = ({
  children,
  reverse,
  first_section_options,
  second_section_options,
}) => {
  const firstSectionWidth = first_section_options.width
  const secondSectionWidth = second_section_options.width
  const wrongSumWidth = firstSectionWidth + secondSectionWidth > 100

  const style = {
    '--first-section-width': `${wrongSumWidth ? 50 : first_section_options.width}%`,
    '--second-section-width': `${wrongSumWidth ? 50 : second_section_options.width}%`,
  } as CSSProperties

  return (
    <div className={cn(classes.row, reverse && classes.reverse)} style={style}>
      {children}
    </div>
  )
}
